import React from "react";
import { AdminStatus } from "../AdminUi";

function fmt(value) {
  return value ? new Date(value).toLocaleString("ar-SA") : "—";
}

function actor(value) {
  return value || "مسؤول النظام";
}

export default function SendAttempts({ attempts = [] }) {
  if (!attempts.length) {
    return <div className="admin-empty">لا توجد محاولات إرسال بعد.</div>;
  }
  return (
    <div className="admin-table-wrap dispute-attempts">
      <table>
        <thead>
          <tr>
            <th>المحاولة</th>
            <th>التاريخ</th>
            <th>المسؤول</th>
            <th>الحالة</th>
            <th>المستلمون</th>
            <th>النتيجة</th>
          </tr>
        </thead>
        <tbody>
          {attempts.map((attempt) => (
            <tr key={attempt.id || attempt.attemptNumber}>
              <td>{attempt.attemptNumber}</td>
              <td>{fmt(attempt.attemptedAt)}</td>
              <td>{actor(attempt.attemptedBy)}</td>
              <td>
                <AdminStatus status={attempt.status === "sent" ? "done" : attempt.status === "failed" ? "rejected" : "pending"}>
                  {attempt.status === "sent"
                    ? "نجحت"
                    : attempt.status === "failed"
                      ? "فشلت"
                      : "قيد الإرسال"}
                </AdminStatus>
              </td>
              <td>
                <div>{(attempt.to || []).join("، ") || "—"}</div>
                {!!attempt.cc?.length && (
                  <small>CC: {attempt.cc.join("، ")}</small>
                )}
              </td>
              <td>
                {attempt.status === "failed"
                  ? attempt.error?.message || "تعذر الإرسال"
                  : attempt.providerMessageId ||
                    attempt.provider ||
                    "تم قبول الطلب من مزود البريد"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
